<template>
  <b-modal hide-footer id="multiCurrency" ref="multiCurrency" title="Multi Currency" @shown="resetData()">
      <div>
        <div class="col-12">
          <div class="row py-2">
            <div class="col-3 align-self-center">
              <span>Currency: </span>
            </div>
            <div class="col-9 align-self-center">
              <div class="dropdown-curve-container">
                <label
                  :class="
                    multiCurrencyConversion.curr_name
                      ? 'shift-up'
                      : ''
                  "
                  >Select Currency</label
                >
                <b-dropdown
                  :text="
                    multiCurrencyConversion.curr_name ? multiCurrencyConversion.curr_name : 'Select Currency'
                  "
                  variant="dropdown-curve"
                  class="w-100"
                >
                  <div class="px-2 pb-2">
                    <input
                      required
                      autofocus
                      type="search"
                      placeholder="Search Currency"
                      class="form-control form-control-sm"
                      v-on:keyup="onSearchCurrency($event.target.value)"
                      v-on:keydown="onSearchCurrency($event.target.value)"
                      v-on:search="onSearchCurrency($event.target.value)"
                      v-model="searchCurrency"
                    />
                  </div>
                  <b-dropdown-item
                    v-for="(currency, currIndex) in CurrencyList"
                    href="#"
                    :key="currIndex"
                    name="currencyDropdown"
                    id="currencyDropdown"
                    v-on:click="selectMultiCurrency(currency)"
                    >{{ currency.curr_name }}</b-dropdown-item
                  >
                </b-dropdown>
              </div>
            </div>
          </div>
          <div class="row py-2">
            <div class="col-3 align-self-center">
              <span>Amount: </span>
            </div>
            <div class="col-md-9 mb-2">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      v-model="multiCurrencyConversion.Amount"
                      :disabled="isConverted"
                      type="text"
                      name="amountToConvert"
                      id="amountToConvert"
                      class="InputAmount"
                      placeholder="."
                    />
                    <label>Amount</label>
                    <span class="currency-symbol">{{multiCurrencyConversion.curr_code}}</span>
                  </div>
                  <Tooltip :title="`Amount To Convert`"  />
                   <VkeyboardFloat
                    :ID="'amountToConvert'"
                    :onClickFun="() => {
                      showVKeyboard = !showVKeyboard
                    }"
                  />
                  <Vkeyboard
                    :inputName="'amountToConvert'"
                    :showOrHide="showVKeyboard"
                    :initialValue="multiCurrencyConversion.Amount"
                    :keyBoardType="'numeric'"
                    @onChangeEvent="() => {}"
                    @onKeyEnter="ConvertCurrency(multiCurrencyConversion.curr_id)"
                    @changeKeyboardInput="multiCurrencyConversion.Amount = $event"
                    @onClickClose="() => {
                      showVKeyboard = false;
                    }"
                  />
                </div>
              </div>
          </div>
          <div class="row py-2" v-if="ConvertedCurrencyToBase">
            <div class="col-3 align-self-center">
              <span>Equals: </span>
            </div>
            <div class="col-md-9 mb-2">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      v-model="ConvertedCurrencyToBase"
                      disabled
                      type="text"
                      name="convertedAmount"
                      id="convertedAmount"
                      class="InputAmount"
                      placeholder="."
                    />
                    <span class="currency-symbol">{{currencyData.curr_code}}</span>
                  </div>
                  <Tooltip :title="`Converted Amount`"  />
                </div>
              </div>
          </div>
        </div>
        <div class="col-md-12 my-3 text-center" v-if="ConvertedCurrencyToBase && ConversionRateToBase && AmountByCustomer">
          Conversion: {{AmountByCustomer + " x " + ConversionRateToBase + " = "}} <span class="font-weight-bold"> {{ConvertedCurrencyToBase + " " + currencyData.curr_code}}</span>
        </div>
        <div class="col-12 pt-3 text-center" v-if="ConvertedCurrencyToBase">
          <button @click="UseConvertedCurrency()" class="btn-blue-lg px-5">
            Accept
          </button>
        </div>
        <div class="col-12 pt-3 text-center" v-else>
          <button @click="ConvertCurrency(multiCurrencyConversion.curr_id)" class="btn-blue-lg px-5" :class="!multiCurrencyConversion.curr_id ? 'disabled' : ''" :disabled="!multiCurrencyConversion.curr_id">
            Convert
            <b-spinner
                v-if="ConversionLoading"
                small
                variant="light"
                label="Spinning"
                class="translate-spinner"
            ></b-spinner>
          </button>
        </div>
      </div>
    </b-modal>
</template>
<script>
import PosService from "@/services/PosService.js";
import MasterService from "@/services/MasterService.js";
import { mapState, mapGetters, mapActions } from "vuex";
import { EventBus } from "@/main";
import Vkeyboard from "@/components/Partials/Vkeyboard.vue";
import VkeyboardFloat from "@/components/Partials/keyboardFloatingToggle.vue";

export default {
  props: {
    showModal: Boolean,
    sectionType: String,
  },
  components: {
    Vkeyboard,
    VkeyboardFloat
  },
  data() {
    return {
      showVKeyboard: false,
      CurrencyList: [],
      CurrencyListCopy: [],
      ConvertedCurrencyToBase: "",
      ConversionRateToBase: "",
      AmountByCustomer: null,
      MiltiCurrId: null,
      searchCurrency: "",

      multiCurrencyConversion: {
        curr_name: "",
        curr_id: null,
        Amount: null,
        curr_code: "",
      },
      ConversionLoading: false,
      currencyData: [],
      isConverted: false,
    };
  },
  watch: {
    showModal(newval) {
      this.$bvModal.show("multiCurrency");
    },
  },
  computed: {
    getcurrency() {
      return this.$store.getters.GET_CURRENCY;
    },
  },
  beforeMount() {
      this.getCurrencyList();
      this.getCurrencyCode();
  },
  methods: {
    resetData() {
      this.ConvertedCurrencyToBase = "",
      this.ConversionRateToBase = "",
      this.AmountByCustomer = null,
      this.MiltiCurrId = null,
      this.searchCurrency = "",

      this.multiCurrencyConversion=  {
        curr_name: "",
        curr_id: null,
        Amount: null,
        curr_code: "",
      }
    },
    UseConvertedCurrency() {
      if(this.sectionType == 'POS') {
        this.$store.dispatch("SET_CASH_INPUT", this.ConvertedCurrencyToBase);
        EventBus.$emit("calculate_change_amount");
        console.log('sectionType POS', this.sectionType);
      } else {
        this.$store.commit("SET_INPUT_AMOUNT", this.ConvertedCurrencyToBase);
        this.$store.commit("SET_MULTICURR_CHANGE");
        console.log('sectionType', this.sectionType);
      }
        this.$store.commit("SET_MULTI_CURR_ID", this.MiltiCurrId);
        this.$store.commit("SET_MULTI_CURR_CONVERSION_RATE", this.ConversionRateToBase);
        this.$store.commit("SET_MULTI_CURR_AMOUNT", this.AmountByCustomer);
        this.$refs.multiCurrency.hide();
    },
    selectMultiCurrency(curr) {
      this.ConvertedCurrencyToBase = "";
      this.ConvertedTotalAmount  = "";
      this.isConverted = false;
      this.AmountByCustomer  = null;
      this.multiCurrencyConversion.curr_name = curr.curr_name;
      this.multiCurrencyConversion.curr_id = curr.curr_id;
      this.multiCurrencyConversion.curr_code = curr.curr_code;
    },
    ConvertCurrency(CurrId) {
      // this.$toasted.show("This Feature is Under Progress")
      // return;
      this.ConversionLoading = true;
      if (!this.multiCurrencyConversion.curr_id) {
        return this.$toasted.show("Please Select Currency")
      } else if (!this.multiCurrencyConversion.Amount) {
        return this.$toasted.show("Please Enter Amount")
      }
      PosService.ConvertCurrency(this.multiCurrencyConversion).then((response) => {
        if(response) {
          const {data} = response;
          console.log("data", data); 
          console.log("response", response);
          if(data && data.data) {
            if(data.data.ConvertedTotalAmount && data.data.ConversionRate && data.data.Amount && data.data.CurrId) {
            this.ConvertedCurrencyToBase = data.data.ConvertedTotalAmount;
            this.ConversionRateToBase = data.data.ConversionRate;
            this.AmountByCustomer = data.data.Amount;
            this.MiltiCurrId = data.data.CurrId;
            this.isConverted = true;
            } else {
              this.$toasted.show(data.message);
            }
          } else {
            this.$toasted.show(data.message)
          }
        }
      }).catch((err) => {
        console.log("err: ", err);
      }).finally(() => {
          this.ConversionLoading = false;
      })
    },
    getCurrencyList: function () {
      let payload = {
        tableName: "ms_currencies",
        curr_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.CurrencyList = data.Records;
            this.CurrencyListCopy = data.Records;
          } else {
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          console.log("Catch Error :", error);
        });
    },
    getCurrencyCode: function () {
      let payload = {
        tableName: "ms_currencies",
        curr_is_active: "Y",
        curr_id:
          this.secureStore.get("BRGLOPCU") &&
          this.secureStore.get("BRGLOPCU").go_value,
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.currencyData = data.Records[0];
            this.$store.commit("GLOBAL_CURR_ID", this.currencyData.curr_id);
          } else {
            // Show Error Message:
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          // Catch Error:
          console.log("Catch Error on getActiveScreenByCinemaId :", error);
        });
    },
    onSearchCurrency() {
      if (this.searchCurrency && this.searchCurrency.length > 0) {
        this.CurrencyList = this.CurrencyListCopy.filter((x) => {
          if (
            x.curr_name &&
            x.curr_name
              .toLowerCase()
              .includes(this.searchCurrency.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.CurrencyList = this.CurrencyListCopy;
      }
    },
  },
};
</script>
<style>
.currency-symbol {
    position: absolute;
    top: 50%;
    right: 10px;
    font-size: 12px;
    transform: translateY(-50%);
  }
  .InputAmount {
    padding-right: 3rem !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/Partials/PosCurrencyConvertor.vue